import { safeErrorMessage } from '../../utils/apiError';

// Download a file from an endpoint that needs the session token (so it
// can't be a plain link). Resolves to '' on success or an error message.
export async function downloadFile(token, url, fallbackName) {
  try {
    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!response.ok) return safeErrorMessage(response, 'Download failed');
    const named = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') || '');
    const objectUrl = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = named ? named[1] : fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
    return '';
  } catch {
    return 'Network error. Please check your connection and try again.';
  }
}
